// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"74246154","867":"6a472cd8","882":"493c0d93","935":"f7303cf0"}[chunkId] + ".chunk.css";
};